export default "__VITE_PUBLIC_ASSET__87aed7fc__"